if (!customElements.get('related-product-options')) {
  class ComponentRelatedProductOptions extends HTMLElement {
    constructor() {
      super()

        this.allProducts = this.dataset.allProducts ? this.dataset.allProducts.split(',') : [];
        this.processedHandles = this.dataset.processed ? this.dataset.processed.split(',') : [];
        this.currentHandle = this.dataset.currentHandle;
        this.usedHandles = parseInt(this.dataset.used);
        this.remainigProducts = this.allProducts.slice(this.usedHandles)
        this.loadedCount = 0
        this.loadSwatches();
    }


    async loadSwatches() {
        const handles = this.remainigProducts
            .filter(handle => handle && !this.processedHandles.includes(handle));
        
        if (!handles.length) return;

        const requests = handles.map(async (handle) => {
            const url = `/products/${handle}?view=metafields.json`;
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP ${response.status} for ${handle}`);
            }
            const json = await response.json();
            return { handle, json };
        })

        const results = await Promise.allSettled(requests);
        for(const res of results) {
            if (res.status === 'fulfilled') {
                const { json } = res.value;
                if (!json) continue;
                this.createSwatch(json)
            } else {
                console.warn('Failed to load:', res.reason)
            }
        }
        
        document.querySelectorAll('.swatch-placeholder[data-settled="false"]').forEach(el => el.remove())
    }

    removePlaceHolder(handle) {
        let elPlaceHolder = this.querySelector(`.swatch-placeholder[data-handle="${handle}"]`);
        if (elPlaceHolder) elPlaceHolder.remove();
    }

    markPlaceholder(handle) {
        let elPlaceHolder = this.querySelector(`.swatch-placeholder[data-handle="${handle}"]`);
        if (elPlaceHolder) elPlaceHolder.dataset.settled = true;
    }

    createSwatch(dataSwatch) {

        const { title, handle } = dataSwatch;

        const swatchImages = dataSwatch?.metafields?.accentuate?.swatch_image;
        if (!swatchImages || swatchImages.length == 0) return;

        let swatchImage = swatchImages[0]?.src;
        if (!swatchImage) return;
 
        this.removePlaceHolder(handle)

        const spanEl = document.createElement('span')
        spanEl.classList.add('visually-hidden')
        spanEl.innerHTML = title;

        const labelInnerEl = document.createElement('div')
        labelInnerEl.classList.add('label-inner', 'flex',  'align-items-center', 'justify-content-center', 'animation')
        labelInnerEl.style.backgroundImage = `url('${swatchImage}')`;

        const divWrapEl = document.createElement('div');

        const linkEl = dataSwatch.available ? document.createElement('a') : document.createElement('div');
        linkEl.classList.add('swatch')
        linkEl.dataset.available = dataSwatch.available;
        linkEl.dataset.handle = handle;
        if (!dataSwatch.available) {
            linkEl.ariaHidden = true;
            linkEl.tabIndex = -1;
        } else {
            linkEl.href = handle;
        }

        labelInnerEl.appendChild(spanEl)
        divWrapEl.appendChild(labelInnerEl);
        linkEl.appendChild(divWrapEl)
        this.appendChild(linkEl)
    }
  }
  customElements.define('related-product-options', ComponentRelatedProductOptions);
}